import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Divider = styled(Box)(() => ({
  height: '1px',
  width: '100%',
  background: 'rgba(221, 221, 234, 1)',
}));

export const CollapseHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '15px 0',

  '.MuiTypography-root': {
    fontSize: '16px',
    lineHeight: '20.8px',
  },
}));

export const Container = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  paddingBottom: '15px',
}));
